import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import WorkspacesSlice from './slices/WorkspacesSlice';
import DiagnosisSlice from './slices/DiagnosisSlice';
import ChatSlice from './slices/chat/ChatSlice';
import UserSlice from './slices/UserSlice';
import PatientSlice from './slices/PatientSlice';
import VirtualHumanSlice from './slices/VirtualHumanSlice';
import SilverstripeAPISlice from './slices/SilverstripeAPISlice';
import ActionSlice from './slices/ActionSlice';
import VHPlayerSlice from './slices/vh-player/VHPlayerSlice';
import ObjectivesSlice from './slices/ObjectivesSlice';
import SpeechToTextSlice from './slices/SpeechToTextSlice';
import CallSlice from '@vh/slices/CallSlice';
import EvaluationSlice from '@vh/slices/EvaluationSlice';

// import monitorReducersEnhancer from './enhancers/monitorReducers'
// import loggerMiddleware from './middleware/logger'

function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: {
      workspaces: WorkspacesSlice.reducer,
      silverstripeAPI: SilverstripeAPISlice.reducer,
      diagnosis: DiagnosisSlice.reducer,
      chat: ChatSlice.reducer,
      user: UserSlice.reducer,
      patient: PatientSlice.reducer,
      virtualHuman: VirtualHumanSlice.reducer,
      action: ActionSlice.reducer,
      vhPlayer: VHPlayerSlice.reducer,
      objectives: ObjectivesSlice.reducer,
      speechToText: SpeechToTextSlice.reducer,
      call: CallSlice.reducer,
      evaluation: EvaluationSlice.reducer,
    },
    middleware: [...getDefaultMiddleware()],
    // preloadedState,
    // enhancers: [monitorReducersEnhancer]
  });

  // if (getConfig("NODE_ENV") !== 'production' && module.hot) {

  //   module.hot.accept('./reducers', () => store.replaceReducer(rootReducer))
  // }

  return store;
}

export default configureAppStore();
